import { render } from "./ShiftsModal.vue?vue&type=template&id=547c0778"
import script from "./ShiftsModal.vue?vue&type=script&lang=js"
export * from "./ShiftsModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__